import {
	Button,
	DialogBackdrop,
} from '@chakra-ui/react';
import type {
	ButtonProps,
	DialogFooterProps,
	DialogHeaderProps,
	DialogRootProps,
	DialogTitleProps,
} from '@chakra-ui/react';
import {
	DialogBody,
	DialogCloseTrigger,
	DialogContent,
	DialogFooter,
	DialogHeader,
	DialogRoot,
	DialogTitle,
	DialogTrigger,
} from '../../../components';

import React from 'react';

export type ConfirmDialog = DialogRootProps;

type ConfirmDialogHeaderProps = DialogHeaderProps & {
	_title?: DialogTitleProps;
};

export const ConfirmDialogHeader = ({ children, _title, ...other }: ConfirmDialogHeaderProps) => {
	return (
		<DialogHeader {...other}>
			<DialogTitle {..._title}>{children}</DialogTitle>
		</DialogHeader>
	);
};

type ConfirmDialogFooterProps = DialogFooterProps & {
	onConfirm:         () => void;
	onCancel:          () => void;
	confirmButtonText: React.ReactNode;
	cancelButtonText:  React.ReactNode;
	isLoading?:        boolean;
	_cancelButton?:    ButtonProps;
	_confirmButton?:   ButtonProps;
};

export const ConfirmDialogFooter = ({
	onConfirm,
	onCancel,
	isLoading,
	_cancelButton,
	_confirmButton,
	confirmButtonText,
	cancelButtonText,
	...other
}: ConfirmDialogFooterProps) => {
	return (
		<DialogFooter
			display={'flex'}
			gap={8}
			justifyContent={'flex-end'}
			{...other}
		>
			<Button disabled={isLoading} variant={'outline'} {..._cancelButton} onClick={onCancel}>
				{cancelButtonText}
			</Button>
			<Button loading={isLoading} {..._confirmButton} onClick={onConfirm}>
				{confirmButtonText}
			</Button>
		</DialogFooter>
	);
};

export const ConfirmDialog = ({ children, ...rest }: ConfirmDialog) => {
	return (
		<DialogRoot {...rest}>
			<DialogBackdrop />
			<DialogContent>
				<DialogCloseTrigger />
				{children}
			</DialogContent>
		</DialogRoot>
	);
};

ConfirmDialog.Header = ConfirmDialogHeader;
ConfirmDialog.Body = DialogBody;
ConfirmDialog.Footer = ConfirmDialogFooter;
ConfirmDialog.Trigger = DialogTrigger;